/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { node, oneOfType, arrayOf } from 'prop-types';

const useStyles = makeStyles({
    root: {
        '& .slick-slider': {
            position: 'relative', display: 'block', boxSizing: 'border-box', WebkitUserSelect: 'none', MozUserSelect: 'none', MsUserSelect: 'none', userSelect: 'none', WebkitTouchCallout: 'none', KhtmlUserSelect: 'none', MsTouchAction: 'pan-y', touchAction: 'pan-y', WebkitTapHighlightColor: 'transparent',
        },
        '& .slick-list': {
            position: 'relative', display: 'block', overflow: 'hidden', margin: '0', padding: '0',
        },
        '& .slick-list:focus': { outline: 'none' },
        '& .slick-list:dragging': { cursor: 'hand' },
        '& .slick-slider .slick-track, & .slick-slider .slick-list': {
            WebkitTransform: 'translate3d(0, 0, 0)', MozTransform: 'translate3d(0, 0, 0)', MsTransform: 'translate3d(0, 0, 0)', OTransform: 'translate3d(0, 0, 0)', transform: 'translate3d(0, 0, 0)',
        },
        '& .slick-track': {
            position: 'relative', top: '0', left: '0', display: 'block', marginLeft: 'auto', marginRight: 'auto',
        },
        '& .slick-track:before, & .slick-track:after': { display: 'table', content: "''" },
        '& .slick-track:after': { clear: 'both' },
        '& .slick-loading .slick-track': { visibility: 'hidden' },
        '& .slick-slide': {
            display: 'none', float: 'left', height: '100%', minHeight: '1px',
        },
        '& [dir="rtl"] .slick-slide': { float: 'right' },
        '& .slick-slide img': { display: 'block' },
        '& .slick-slide.slick-loading img': { display: 'none' },
        '& .slick-slide.dragging img': { pointerEvents: 'none' },
        '& .slick-initialized .slick-slide': { display: 'block' },
        '& .slick-loading .slick-slide': { visibility: 'hidden' },
        '& .slick-vertical .slick-slide': { display: 'block', height: 'auto', border: '1px solid transparent' },
        '& .slick-arrow.slick-hidden': { display: 'none' },
        '& .slick-prev, & .slick-next': { left: '-25px' },
        '& .slick-prev:hover, & .slick-prev:focus, & .slick-next:hover, & .slick-next:focus': { color: 'transparent', outline: 'none', background: 'transparent' },
        '& .slick-prev:hover:before, & .slick-prev:focus:before, & .slick-next:hover:before, & .slick-next:focus:before': { opacity: '1' },
        '& .slick-prev.slick-disabled:before, & .slick-next.slick-disabled:before': { opacity: '.25' },
        '& .slick-dotted.slick-slider': { marginBottom: '30px' },
        '& .slick-dots': {
            position: 'absolute', bottom: '-25px', display: 'block', width: '100%', padding: '0', margin: '0', listStyle: 'none', textAlign: 'center',
        },
        '& .slick-dots li': {
            position: 'relative', display: 'inline-block', width: '20px', height: '20px', margin: '0 5px', padding: '0', cursor: 'pointer',
        },
        '& .slick-dots li button': {
            fontSize: '0', lineHeight: '0', display: 'block', width: '20px', height: '20px', padding: '5px', cursor: 'pointer', color: 'transparent', border: '0', outline: 'none', background: 'transparent',
        },
        '& .slick-dots li button-hover': { outline: 'none' },
        '& .slick-dots -li button:focus': { outline: 'none' },
        '& .slick-dots li button:hover:before': { opacity: '1' },
        '& .slick-dots li button:focus:before': { opacity: '1' },
        '& .slick-dots li button:before': {
            fontFamily: "'slick'", fontSize: '6px', lineHeight: '20px', position: 'absolute', top: '0', left: '0', width: '20px', height: '20px', content: "'•'", textAlign: 'center', opacity: '.25', color: 'black', WebkitFontSmoothing: 'antialiased', MozOsxFontSmoothing: 'grayscale',
        },
        '& .slick-dots li.slick.active button:before': { opacity: '.75', color: 'black' },
    },
});

function SlickCSSWraper({ children }) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            {children}
        </div>
    );
}

SlickCSSWraper.propTypes = {
    children: oneOfType([
        arrayOf(node),
        node,
    ]).isRequired,
};

export default SlickCSSWraper;
